<template>
  <tr>
    <td>
      <EllipsisTip>{{ item.keyword }}</EllipsisTip>
    </td>
    <td>
      <div class="c-text--center">
        <p>{{ item.createdAt | dateText('YYYY.MM.DD') }}</p>
      </div>
    </td>
    <td>
      <Button
        :to="{
          name: 'contentPlansSurvey',
          query: {
            createdAt: convertDateJst,
            keyword: item.keyword
          }
        }"
        size="w180"
        fsize="f14"
        icon="arrow_r"
        variant="main"
      >
        結果を見る
      </Button>
    </td>
    <td class="c-text--center">
      <Button variant="delete" :disabled="isDeleting" @click="deleteItem">
        削除
      </Button>
    </td>
  </tr>
</template>

<script>
import Button from '@/components/Button';
import EllipsisTip from '@/components/EllipsisTip';
import * as dayjs from 'dayjs';
import 'dayjs/locale/ja';
import apiProjects from '@/api/projects';
import utc from 'dayjs/plugin/utc.js';
dayjs.extend(utc);

export default {
  props: ['item', 'project'],

  data() {
    return {
      isDeleting: false
    };
  },

  components: {
    Button,
    EllipsisTip
  },

  computed: {
    //
    // Awatea側の修正を行った日を判定条件として処理を出力する日付を変更する
    // 1.Awatea側の修正を行う前のKWD -> データ取得日付を世界標準日付にする
    // 2.Awatea側の修正を行った後のKWD -> データ取得日付を日本時間日付にする
    //
    convertDateJst() {
      // Awatea側の順位保存日付を世界時間から日本時間に切り替えた日を環境変数から取得
      let localChangeDate = dayjs(
        process.env.VUE_APP_AWATEA_SAVE_LOCAL_CHANGE_DATE
      );

      // Awateaの順位取得結果ファイルの保存日をJSTに変更した以降に登録した調査KWDの場合
      // 環境変数を設定し忘れている場合もUTCでデータ取得する（過去登録データの取得に影響がないようにするため
      if (
        dayjs(this.item.createdAt).valueOf() < localChangeDate.valueOf() ||
        !process.env.VUE_APP_AWATEA_SAVE_LOCAL_CHANGE_DATE
      ) {
        return dayjs(this.item.createdAt)
          .utc()
          .format('YYYY-MM-DD');
      } else {
        return this.$options.filters.dateText(
          this.item.createdAt,
          'YYYY-MM-DD'
        );
      }
    }
  },
  methods: {
    deleteItem() {
      if (this.isDeleting) {
        return;
      }

      this.isDeleting = true;

      apiProjects.contentPlans.keywords
        .delete(this.item.id, this.auth.idToken, this.project.id, this.item.id)
        .then(response => {
          this.$emit('delete', this.item);
        })
        .catch(error => {
          this.isDeleting = false;
        });
    }
  }
};
</script>
